module.exports = __webpack_public_path__ + "media/images/emblems/Mettauertal_Wappen-6868a0cf51319a5a0fafbc491649f975.png";